import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid, Form, Checkbox, Ref } from "semantic-ui-react";
import { RoomboxDetailsHeader, RatesGroup, Gallery } from "../";
import RoomData from "../RoomData";
import { Amenities, NoResults, ContactUs, RawHTML } from "../common";
import Only from "react-only-when";
import styles from "./styles.less";
import RatesTable from "../RatesTable/RatesTable";

class RoomboxDetails extends Component {
  state = {
    ratesHeightExpanded: null,
    ratesHeightCollapsed: 0,
    initialLoading: true
  };
  componentDidMount() {
    this.calcRatesSize();
  }
  onRateSelection = ({ ...rateSelectedParams }) => {
    const {
      onRateSelection,
      room,
      clubUserLoggedIn,
      isClubPricesInterested,
      showSimpleClubLoginModal,
      isMobileView
    } = this.props;
    if (isMobileView && !clubUserLoggedIn && isClubPricesInterested) {
      showSimpleClubLoginModal();
    } else {
      onRateSelection({ ...rateSelectedParams, roomId: room.id });
    }
  };

  showSimpleClubLoginModal = () => {
    const {
      clubUserLoggedIn,
      isClubPricesInterested,
      showSimpleClubLoginModal
    } = this.props;
    if (!clubUserLoggedIn && isClubPricesInterested) {
      showSimpleClubLoginModal();
    }
  };

  onRateReadMore = ({ rateId }) => {
    const { onRateReadMore, room } = this.props;
    onRateReadMore(rateId, room.id);
  };

  onShowMoreAmenities = () => {
    const { onShowMoreAmenities, room } = this.props;
    onShowMoreAmenities(room.id);
  };

  renderHeader = () => {
    const {
      titles,
      room,
      isRtl,
      isMobileView,
      showFullHeaderDetails,
      onRoomDetailsClick,
      onShowRatesClick,
      onShowContactUsForm,
      ratesGroupVisible
    } = this.props;

    return (
      <RoomboxDetailsHeader
        isRtl={isRtl}
        titles={titles}
        room={room}
        isMobileView={isMobileView}
        className={cx(styles.stackedHeader, {
          [styles.mobileView]: isMobileView
        })}
        showFullHeaderDetails={showFullHeaderDetails}
        onRoomDetailsClick={onRoomDetailsClick}
        onShowRatesClick={onShowRatesClick}
        onShowContactUsForm={onShowContactUsForm}
        ratesGroupVisible={ratesGroupVisible}
      />
    );
  };

  handleRefToRoomboxDetailsHeader = ref => {
    const { roomBoxDetailsHeaderRef } = this.props;
    if (roomBoxDetailsHeaderRef) {
      roomBoxDetailsHeaderRef(ref);
    }
  };

  renderRatesGroup = () => {
    const {
      selectedRateIdOfCurrentPax,
      isRtl,
      titles,
      room,
      showAvailability,
      lowAvailabilityCount,
      clubUserLoggedIn,
      isClubActive,
      isClubPricesInterested,
      clubPercentageDiscount,
      ratesGroupRef,
      ShowCancellationPolicy,
      selectedPaxId,
      //isDealMode,
      isMobileView,
      isIE,
      displayPriceWithoutTaxes
    } = this.props;
    const showClubPrices = isClubPricesInterested || clubUserLoggedIn;
    const hasRates =
      room.rates && room.rates.filter(rate => rate.availability > 0).length;
    const numberOfAmenitiesToShow = 5;
    const amenitiesPreviewLimit =
      room.amenities && room.amenities.length < numberOfAmenitiesToShow
        ? room.amenities.length
        : numberOfAmenitiesToShow;
    const amenitiesToPreview =
      room.amenities && room.amenities.slice(0, amenitiesPreviewLimit);
    // const groupedRates = isDealMode
    //   ? this.groupRatesByPackages(room.rates)
    //   : room.rates;
    return (
      <Ref innerRef={this.handleRefToRoomboxDetailsHeader}>
        <Grid
          className={styles.ratesWrapper}
          textAlign={isRtl ? "right" : "left"}
        >
          {isMobileView && (
            <Grid.Column width={16} className={styles.headerWrapper}>
              <Grid.Column
                className={cx(styles.amenities, { [styles.rtl]: isRtl })}
                width={16}
              >
                <Amenities
                  amenities={amenitiesToPreview}
                  isRtl={isRtl}
                  isMobileView={isMobileView}
                />
              </Grid.Column>
              {room.amenities &&
                room.amenities.length > numberOfAmenitiesToShow && (
                  <Grid.Column width={16}>
                    <div className={cx(styles.showMoreAmenities)}>
                      <button
                        onClick={this.onShowMoreAmenities}
                        className={styles.showMoreAmenitiesBtn}
                      >
                        {titles.ShowMoreAmenities}
                      </button>
                    </div>
                  </Grid.Column>
                )}
            </Grid.Column>
          )}
          {!!hasRates &&
            isClubActive &&
            !clubUserLoggedIn &&
            isMobileView && (
              <Grid.Column width={16} className={styles.filterStripeWrapper}>
                {this.renderFilterStripe()}
              </Grid.Column>
            )}
          <Grid.Column width={16}>
            <Ref innerRef={ratesGroupRef}>
              <Form size="large">
                <Grid
                  stretched
                  textAlign={isRtl ? "right" : "left"}
                  className={cx({ [styles.ieIsShit]: isIE })}
                >
                  {hasRates ? (
                    isMobileView ? (
                      <RatesGroup
                        showClubPrices={showClubPrices}
                        isRtl={isRtl}
                        titles={titles}
                        rates={room.rates}
                        showAvailability={showAvailability}
                        lowAvailabilityCount={lowAvailabilityCount}
                        name={room.name}
                        categoryId={room.id}
                        requestDescriptor={room.requestDescriptor}
                        selectedItemId={selectedRateIdOfCurrentPax}
                        onItemClick={this.onRateSelection}
                        onReadeMoreClick={this.onRateReadMore}
                        ShowCancellationPolicy={ShowCancellationPolicy}
                        isIE={isIE}
                      />
                    ) : (
                      <RatesTable
                        key={room.id + selectedPaxId}
                        groupParam={"priceCode"}
                        titleParam={"priceName"}
                        showClubPrices={showClubPrices}
                        isRtl={isRtl}
                        titles={titles}
                        rates={room.rates}
                        showAvailability={showAvailability}
                        lowAvailabilityCount={lowAvailabilityCount}
                        name={room.name}
                        categoryId={room.id}
                        requestDescriptor={room.requestDescriptor}
                        selectedItemId={selectedRateIdOfCurrentPax}
                        onItemClick={this.onRateSelection}
                        onReadeMoreClick={this.onRateReadMore}
                        ShowCancellationPolicy={ShowCancellationPolicy}
                        showSimpleClubLoginModal={this.showSimpleClubLoginModal}
                        isClubActive={isClubActive}
                        clubUserLoggedIn={clubUserLoggedIn}
                        clubPercentageDiscount={clubPercentageDiscount}
                        shouldGroupByPackageId={true}
                        isIE={isIE}
                        displayPriceWithoutTaxes={displayPriceWithoutTaxes}
                      />
                    )
                  ) : (
                    this.renderNoResultsPage()
                  )}
                </Grid>
              </Form>
            </Ref>
          </Grid.Column>
        </Grid>
      </Ref>
    );
  };

  renderGallery = () => {
    const { images, isRtl } = this.props;
    return <Gallery images={images} isRtl={isRtl} />;
  };

  renderFilterStripe = () => {
    const {
      titles,
      isRtl,
      onClubPricesInterestingClick,
      isClubPricesInterested
    } = this.props;
    return (
      <div className={cx(styles.filterStripe, { [styles.rtl]: isRtl })}>
        <Checkbox
          id="club-show"
          name="club-show"
          size="big"
          onChange={onClubPricesInterestingClick}
          checked={isClubPricesInterested}
        />
        <div className={styles.title}>
          <label htmlFor="club-show">{titles.ShowClubMemberRates}</label>
        </div>
      </div>
    );
  };

  calcRatesSize = () => {
    const { expandbleState } = this.props;
    const isInitial = this.state.initialLoading;
    if (isInitial && this.ratesRef) {
      this.setState({
        ratesHeightExpanded: expandbleState ? this.ratesRef.offsetHeight : null,
        ratesHeightCollapsed: 0,
        initialLoading: false
      });
    }
  };

  renderContactUs = () => {
    const {
      titles,
      hotelData,
      isMobileView,
      room,
      lang,
      checkinDate,
      checkoutDate,
      selectedOption,
      currentPaxCombination,
      contactUsSubmitingStatus,
      submitContactUsForm,
      contactUsFormRef
    } = this.props;

    const needToShowForm = !contactUsSubmitingStatus.succeed == true;

    return (
      <Ref innerRef={contactUsFormRef}>
        <Grid.Column
          width={16}
          className={cx(
            styles.viewPort,
            styles.relaxed,
            styles.contactUsWrapper,
            {
              [styles.mobileView]: isMobileView
            }
          )}
        >
          <ContactUs
            lang={lang}
            onSubmit={submitContactUsForm}
            checkinDate={checkinDate}
            checkoutDate={checkoutDate}
            selectedOption={selectedOption}
            pax={currentPaxCombination}
            room={room}
          >
            {({ onSubmit }) =>
              needToShowForm ? (
                <React.Fragment>
                  <div className={styles.contactUsHeader}>
                    <Only when={!!titles}>
                      <RawHTML
                        className={cx(styles.headerText, styles.inOrderTo)}
                        html={titles.ToOrderThisRoomContactUs}
                      />
                    </Only>
                    <ContactUs.OptionsToContact
                      className={styles.optionToContant}
                      phoneNumber={hotelData.HotelPhone}
                      isMobileView={isMobileView}
                      titleCall={titles.Call}
                    />
                  </div>
                  <ContactUs.OrStrip orTitle={titles.Or} />
                  <div
                    className={cx(styles.headerText, styles.sendYourRequest)}
                  >
                    {titles.SendYourRequestAndWeWillReturn}
                  </div>
                  <ContactUs.ContactUsForm
                    onSubmit={onSubmit}
                    titles={titles}
                    submitingStatus={contactUsSubmitingStatus}
                    isMobileView={isMobileView}
                    requestType={titles.RequestedRoom}
                  />
                </React.Fragment>
              ) : (
                <ContactUs.ContactUsConfirmation titles={titles} />
              )
            }
          </ContactUs>
        </Grid.Column>
      </Ref>
    );
  };

  renderNoResultsPage = () => {
    const { titles, isRtl } = this.props;
    return (
      <Grid.Column verticalAlign="middle" className={styles.noRates}>
        <NoResults
          NoResultsMessage={titles.NoProductsForThisRoom}
          isRtl={isRtl}
        />
      </Grid.Column>
    );
  };

  renderDesktopRoomData = () => {
    const {
      titles,
      room,
      isRtl,
      isMobileView,
      showFullHeaderDetails,
      onRoomDetailsClick,
      onShowRatesClick,
      onShowContactUsForm,
      ratesGroupVisible,
      onShowMoreAmenities,
      onShowRoomGalleryPopUp,
      switchImagesAutomatically,
      selectedPaxId,
      images,
      toggleExpandbleResultsView,
      expandbleState
    } = this.props;

    return (
      <RoomData
        isRtl={isRtl}
        titles={titles}
        room={room}
        isMobileView={isMobileView}
        className={cx(styles.stackedHeader, {
          [styles.mobileView]: isMobileView
        })}
        showFullHeaderDetails={showFullHeaderDetails}
        onRoomDetailsClick={onRoomDetailsClick}
        onShowRatesClick={onShowRatesClick}
        onShowContactUsForm={onShowContactUsForm}
        ratesGroupVisible={ratesGroupVisible}
        onShowMoreAmenities={onShowMoreAmenities}
        onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
        switchImagesAutomatically={switchImagesAutomatically}
        images={images}
        selectedPaxId={selectedPaxId}
        toggleExpandbleResultsView={toggleExpandbleResultsView}
        expandbleState={expandbleState}
      />
    );
  };

  renderMobileRoomHeader = () => {
    return (
      <Grid.Column
        mobile={16}
        tablet={8}
        computer={8}
        className={cx(styles.viewPort, styles.relaxed)}
      >
        <div
          className={cx(styles.rail, styles.alphaColor)}
          internal
          position="left"
        >
          {this.renderHeader()}
        </div>
        <Grid.Column>{this.renderGallery()}</Grid.Column>
      </Grid.Column>
    );
  };

  setRatesRef = ref => (this.ratesRef = ref);

  render() {
    const { visibleRoomPage, room, isMobileView } = this.props;
    return (
      <Grid
        stackable
        className={cx(styles.roomboxDetails, styles.relativeContainer)}
        key={room && room.id}
      >
        {isMobileView
          ? this.renderMobileRoomHeader()
          : this.renderDesktopRoomData()}
        <Only when={!room.requestedRoom}>
          <Grid.Column
            width={16}
            className={cx(styles.viewPort, styles.relaxed)}
          >
            <div key={visibleRoomPage}>{this.renderRatesGroup()}</div>
          </Grid.Column>
        </Only>
        <Only when={!!room.requestedRoom}>{this.renderContactUs()}</Only>
      </Grid>
    );
  }
}

RoomboxDetails.defaultProps = {
  ratesGroupRef: () => {},
  roomBoxDetailsHeaderRef: () => {},
  contactUsFormRef: () => {}
};

RoomboxDetails.propTypes = {
  isRtl: PropTypes.bool,
  hotelData: PropTypes.object.isRequired,
  visibleRoomPage: PropTypes.string,
  selectedRateIdOfCurrentPax: PropTypes.string,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  selectedOption: PropTypes.object,
  contactUsSubmitingStatus: PropTypes.object,
  currentPaxCombination: PropTypes.object,
  submitContactUsForm: PropTypes.func,
  titles: PropTypes.object,
  lang: PropTypes.string,
  isMobileView: PropTypes.bool,
  images: PropTypes.array,
  room: PropTypes.object,
  showAvailability: PropTypes.bool,
  lowAvailabilityCount: PropTypes.number,
  isClubActive: PropTypes.bool,
  showFullHeaderDetails: PropTypes.bool,
  isClubPricesInterested: PropTypes.bool,
  clubUserLoggedIn: PropTypes.bool,
  onRoomDetailsClick: PropTypes.func,
  onRateSelection: PropTypes.func,
  onShowRatesClick: PropTypes.func,
  onShowContactUsForm: PropTypes.func,
  onRateReadMore: PropTypes.func,
  onShowMoreAmenities: PropTypes.func,
  ratesGroupRef: PropTypes.func,
  contactUsFormRef: PropTypes.func,
  roomBoxDetailsHeaderRef: PropTypes.func,
  onClubPricesInterestingClick: PropTypes.func,
  showSimpleClubLoginModal: PropTypes.func,
  ShowCancellationPolicy: PropTypes.bool,
  isIE: PropTypes.bool,
  onShowRoomGalleryPopUp: PropTypes.func,
  ratesGroupVisible: PropTypes.bool,
  clubPercentageDiscount: PropTypes.number,
  switchImagesAutomatically: PropTypes.bool,
  selectedPaxId: PropTypes.number,
  toggleExpandbleResultsView: PropTypes.func,
  expandbleState: PropTypes.bool,
  displayPriceWithoutTaxes: PropTypes.bool
};

export default RoomboxDetails;



// WEBPACK FOOTER //
// ./src/components/RoomboxDetails/RoomboxDetails.js